import React from 'react'

import { useFlag } from '@sketch/modules-common'
import { Button } from '@sketch/components'

import EmptyState from 'modules/shares/components/EmptyState'
import DocumentListEmptyState from 'modules/shares/components/DocumentListEmptyState'

interface CollectionEmptyStateProps {
  onAddDocumentClick: () => void
  userCanManageCollection?: boolean
  search?: string
}

const CollectionEmptyState = (props: CollectionEmptyStateProps) => {
  const { onAddDocumentClick, search, userCanManageCollection } = props

  /**
   * This FF should be removed from here on the ticket
   * https://github.com/sketch-hq/Cloud/issues/16669
   */
  const isOnboardingEmptyStatesOn = useFlag('onboarding-empty-states')

  const action = userCanManageCollection && (
    <Button buttonStyle="primary-32" onClick={onAddDocumentClick}>
      Add Documents...
    </Button>
  )

  /**
   * If there's a search result we default to the old layout with the icon
   * https://sketch.slack.com/archives/C04N2EPHUGN/p1680696902971989?thread_ts=1680696398.697479&cid=C04N2EPHUGN
   *
   * After the FF 'onboarding-empty-states' is removed the "!isOnboardingEmptyStatesOn" condition should
   * be removed from the if statement
   * https://github.com/sketch-hq/Cloud/issues/16669
   */
  if (!isOnboardingEmptyStatesOn || search) {
    return (
      <EmptyState
        title="No documents added to collection yet"
        description="Choose a document you want to add to the collection, then select Move > To Collection from the document menu."
        icon={'documentPlaceholder'}
        callToAction={action}
        search={search}
      />
    )
  }

  return (
    <DocumentListEmptyState
      title="No documents added to collection yet"
      description="Choose a document you want to add to the collection, then select Move > To Collection from the document menu."
      editorialContent="empty-state-collection"
      actions={action}
    />
  )
}

export default CollectionEmptyState
